import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Redirect non-hash reset-password email links (e.g. /reset-password?token=...) to hash format (/#/reset-password?token=...)
if (window.location.pathname === '/reset-password' && window.location.search.includes('token=')) {
    window.location.replace(window.location.origin + '/#' + window.location.pathname + window.location.search)
}
import {createDeviceDetector} from "next-vue-device-detector";

import 'bootstrap/dist/css/bootstrap.css' // add
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import "@/assets/scss/common.scss"

const device = createDeviceDetector()

createApp(App)
    .use(router)
    .use(device)
    .mount('#app')

